/*let templateSchemaFormPicklist = `
    <div class="form-group" ng-class="{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }" >
        <label class="control-label" ng-show="showTitle()">{{form.title}}</label>

        <p class="input-group">
          <input type="text" class="form-control" uib-datepicker-popup="{{form.format}}" ng-model="$$value$$" is-open="opened" datepicker-options="form.dateOptions" ng-required="true" close-text="Close" alt-input-formats="form.altInputFormats" />
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="opened = true"><i class="glyphicon glyphicon-calendar"></i></button>
          </span>
        </p>

        <p uib-timepicker ng-model="mytime" hour-step="form.hstep" minute-step="form.mstep" show-meridian="form.ismeridian"></p>

    </div>
`;*/

let templateSchemaFormDateTimePicker = `
    <div class="form-group" ng-init="popupOpen=false" ng-class="{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }" >
        <label class="control-label" ng-show="showTitle()">{{form.title}}</label>

        <p class="input-group">
           <input type="text" class="form-control" ng-model="$$value$$" uib-datepicker-popup is-open="popupOpen" close-text="Close" />
           <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="popupOpen=true"><i class="glyphicon glyphicon-calendar"></i></button>
          </span>
        </p>

       <!-- <combined-date-time-picker sf-field-model="model" form="form"></combined-date-time-picker> -->
    </div>
`;

angular.module("schemaForm").run(["$templateCache", function($templateCache) {
  $templateCache.put("directives/decorators/bootstrap/dtpicker/dtpicker.html",templateSchemaFormDateTimePicker);
}]);

angular.module('schemaForm-dtpicker', ['schemaForm']).config(
  ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider,  schemaFormDecoratorsProvider, sfPathProvider) {

      var dtpicker = function(name, schema, options) {

        if ((schema.type == 'string') && schema.format == 'date') {

          /*
          if (name = "dt") {
            console.log("name", name);
            console.log("schema", schema);
            console.log("options", options);
          }
          */

          var f = schemaFormProvider.stdFormObj(name, schema, options);
          f.key  = options.path;
          f.type = 'dtpicker';
          options.lookup[sfPathProvider.stringify(options.path)] = f;
          return f;
        }
      };

      schemaFormProvider.defaults.string.unshift(dtpicker);

      //Add to the bootstrap directive
      schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'dtpicker',
        'directives/decorators/bootstrap/dtpicker/dtpicker.html');
      schemaFormDecoratorsProvider.createDirective('dtpicker',
        'directives/decorators/bootstrap/dtpicker/dtpicker.html');
    }]);



// WEBPACK FOOTER //
// ./client/app/schema-form.datetimepicker.js